import moment from "moment";
// Stream Started Imports
// import Echo from 'laravel-echo';
// import {Stream2Player} from "./stream2-player";

const CountDownTimer = {};
(function(o) {

    o.$months = null;
    o.$days = null;
    o.$hours = null;
    o.$minutes = null;
    o.$seconds = null;
    o.videoId = null;

    o.initialize = function (videoId = null) {
        o.$months = $('#stream2-countdown-timer-months');
        o.$days = $('#stream2-countdown-timer-days');
        o.$hours = $('#stream2-countdown-timer-hours');
        o.$minutes = $('#stream2-countdown-timer-minutes');
        o.$seconds = $('#stream2-countdown-timer-seconds');
        o.startTimer($('.stream2-countdown-timer').attr('data-end-date'));
    }

    o.startTimer = function (countdownDate) {
        setInterval(function () {
            let now = moment();
            let end = moment.utc(countdownDate)
            // Find the distance between now and the count down date
            let duration = moment.duration(end.diff(now));
            // If the count down is finished reload the page
            if (Math.floor(end.diff(now)/1000) === 0) {
                location.reload();
            }
            o.updateTimer(duration);
        }, 1000);
    }

    o.updateTimer = function (duration) {
        o.updateTimeNumber(o.$months, duration.months());
        o.updateTimeNumber(o.$days, duration.days());
        o.updateTimeNumber(o.$hours, duration.hours());
        o.updateTimeNumber(o.$minutes, duration.minutes());
        o.updateTimeNumber(o.$seconds, duration.seconds());
    }

    o.updateTimeNumber = function ($element, number) {
        if(number > 0) {
            $element.text(String(number).padStart(2, '0'));
        } else {
            $element.text('00');
        }
    }

    o.hasCountDownTimer = function () {
        return $('.stream2-countdown-timer').length > 0;
    }

    o.append = function (html, videoId) {
        $(window.stream2Player.el()).closest('.video-js').find('.stream2-countdown-timer').remove();
        $(window.stream2Player.el()).closest('.video-js').prepend($(html));
        o.initialize(videoId);
    }

    o.remove = function () {
        $(window.stream2Player.el()).closest('.video-js').find('.stream2-countdown-timer').remove();
    }

})(CountDownTimer);

export { CountDownTimer }

